

import { computed, ref } from 'vue'
import moment from 'moment';
import {FilterMatchMode, FilterOperator} from "primevue/api";
import router from "@/router";
import {useToast} from "primevue/usetoast";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useConfirm } from "primevue/useconfirm";
import {BaoCaoCoSoLaoDong} from "@/models/baoCaoCoSoLaoDong";
import {ThongTinLaoDong} from "@/models/thongTinLaoDong";
import CDCRepository from "@/services/CDCRepository";
import {BaoCaoYTeLaoDongTuyenHuyen} from "@/models/baoCaoYTeLaoDongTuyenHuyen";
import {TongSoMau} from "@/models/tongSoMau";
import {BaoCaoKetQuaHoatDongYTKDThang} from "@/models/baoCaoKetQuaHoatDongYTKDThang";
import {BaoCaoKetQuaHoatDongYTKD6Thang} from "@/models/baoCaoKetQuaHoatDongYTKD6Thang";
import {BaoCaoKetQuaHoatDongYTKDTuan} from "@/models/baoCaoKetQuaHoatDongYTKDTuan";
import {BaoCaoKetQuaHoatDongYTKDNam} from "@/models/baoCaoKetQuaHoatDongYTKDNam";
import {DanhSachBaoCaoThang} from "@/models/danhSachBaoCaoThang";
import axios from "axios";
import {BaoCaoKetQuaHoatDongYTKDNgay} from "@/models/baoCaoKetQuaHoatDongYTKDNgay";
import {DanhSachTuan} from "@/models/danhSachTuan";
import {ThoiGian} from "@/models/thoiGian";


export default {
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const store = useStore();
    const date = ref();
    const dateWeek = ref();
    const date6Month = ref();
    const dateYear = ref();
    const dateDay = ref();
    const service = ref("");
    const router = useRouter();
    const baoCao = ref({} as BaoCaoKetQuaHoatDongYTKDThang);
    const baoCao6Thang = ref({} as BaoCaoKetQuaHoatDongYTKD6Thang);
    const baoCaoTuan = ref({} as BaoCaoKetQuaHoatDongYTKDTuan);
    const baoCaoNam = ref({} as BaoCaoKetQuaHoatDongYTKDNam);
    const baoCaoNgay = ref({} as BaoCaoKetQuaHoatDongYTKDNgay);
    const listBaoCaoThang = ref([] as DanhSachBaoCaoThang[]);
    const listBaoCaoTuan = ref([] as DanhSachBaoCaoThang[]);
    const listBaoCao6Thang = ref([] as DanhSachBaoCaoThang[]);
    const listBaoCaoNam = ref([] as DanhSachBaoCaoThang[]);
    const listBaoCaoNgay = ref([] as DanhSachBaoCaoThang[]);
    const baoCaoThangShow = ref(false);
    const baoCaoTuanShow = ref(false);
    const baoCao6ThangShow = ref(false);
    const baoCaoNgayShow = ref(false);
    const baoCaoNamShow = ref(false);
    const loadingData = ref(false);
    const selectCalendar = () => {
      if((date.value[0] != null)&&(date.value[1] != null))
      {
        listBaoCaoThang.value = [];
        CDCRepository.getListBaoCaoThang(date.value[0]/1000, date.value[1]/1000)
            .then((response) => {
              listBaoCaoThang.value = response.data;
              console.log("@@@@@@@@@################ list: " + JSON.stringify(listBaoCaoThang.value));
              if(listBaoCaoThang.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };

    const selectCalendarWeek = () => {
      if((dateWeek.value[0] != null)&&(dateWeek.value[1] != null))
      {
        listBaoCaoTuan.value = [];
        CDCRepository.getListBaoCaoTuan(dateWeek.value[0]/1000, dateWeek.value[1]/1000)
            .then((response) => {
              listBaoCaoTuan.value = response.data;
              console.log("@@@@@@@@@################ list: " + JSON.stringify(listBaoCaoTuan.value));
              if(listBaoCaoTuan.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };

    const selectCalendar6Month = () => {
      if((date6Month.value[0] != null)&&(date6Month.value[1] != null))
      {
        listBaoCao6Thang.value = [];
        CDCRepository.getListBaoCao6Thang(date6Month.value[0]/1000, date6Month.value[1]/1000)
            .then((response) => {
              listBaoCao6Thang.value = response.data;
              console.log("@@@@@@@@@################ list: " + JSON.stringify(listBaoCao6Thang.value));
              if(listBaoCao6Thang.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };

    const selectCalendarYear = () => {
      if((dateYear.value[0] != null)&&(dateYear.value[1] != null))
      {
        listBaoCaoNam.value = [];
        CDCRepository.getListBaoCaoNam(dateYear.value[0]/1000, dateYear.value[1]/1000)
            .then((response) => {
              listBaoCaoNam.value = response.data;
              console.log("@@@@@@@@@################ list: " + JSON.stringify(listBaoCaoNam.value));
              if(listBaoCaoNam.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };
    const selectCalendarDay = () => {
      if((dateDay.value[0] != null)&&(dateDay.value[1] != null))
      {
        listBaoCaoNgay.value = [];
        CDCRepository.getListBaoCaoNgay(dateDay.value[0]/1000, dateDay.value[1]/1000)
            .then((response) => {
              listBaoCaoNgay.value = response.data;
              console.log("@@@@@@@@@################ list: " + JSON.stringify(listBaoCaoNgay.value));
              if(listBaoCaoNgay.value.length < 1){
                toast.add({
                  severity: 'warn',
                  summary: 'Báo cáo',
                  detail:'Không tìm thấy báo cáo trong khoản thời gian đã chọn',
                  life: 2500
                })
              }
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })})
      }
    };


    //selectCalendar();

    const clearCalendar = () => {
      listBaoCaoThang.value = [];
      listBaoCaoTuan.value = [];
      listBaoCao6Thang.value = [];
      listBaoCaoNam.value = [];
    }
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ baoCaoCoSoLaoDong aaaa: ");
    const initDb = () => {
      baoCao.value.cuaKhauDoiVoiNguois = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6},
        {viTri: "Cảng Đà Nẵng ->> Nhập cảnh ->> Tổng số", id: 7},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18},
      ];
      baoCao.value.cuaKhauPhuongTiens = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
      ];
      baoCao.value.cuaKhauHangHoas = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, buuPham: {}, hangHoaKhac: {}},
      ];
      
      baoCao.value.cuaKhauThiThes = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, thiThe: {}, haiCot: {}, troCot: {}},
      ];
      baoCao.value.cuaKhauViSinhs = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
      ];
//// bao cao 6 thang////


      baoCaoNgay.value.cuaKhauDoiVoiNguois =
      baoCao6Thang.value.cuaKhauDoiVoiNguois = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6},
        {viTri: "Cảng Đà Nẵng ->> Nhập cảnh ->> Tổng số", id: 7},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18},
      ];
      baoCaoNgay.value.cuaKhauPhuongTiens =
      baoCao6Thang.value.cuaKhauPhuongTiens = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
      ];
      baoCaoNam.value.cuaKhauHangHoas =
      baoCaoNgay.value.cuaKhauHangHoas =
      baoCao6Thang.value.cuaKhauHangHoas = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, buuPham: {}, hangHoaKhac: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, buuPham: {}, hangHoaKhac: {}},
      ];

      baoCaoNam.value.cuaKhauThiThes =
      baoCaoNgay.value.cuaKhauThiThes =
      baoCao6Thang.value.cuaKhauThiThes = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, thiThe: {}, haiCot: {}, troCot: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, thiThe: {}, haiCot: {}, troCot: {}},
      ];
      baoCaoNam.value.cuaKhauViSinhs =
      baoCaoNgay.value.cuaKhauViSinhs =
      baoCao6Thang.value.cuaKhauViSinhs = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, mauViSinh: {}, sanPhamSinhHoc: {}, boPhanCoTheNguoi: {}},
      ];
      baoCaoNam.value.tiemChungs =
      baoCaoNgay.value.tiemChungs =
      baoCao6Thang.value.tiemChungs = [
        {tenBenh: "Tả", tenVacxin: "Morcvax"},
      ];
      baoCaoNam.value.giamSatDichBenhs =
      baoCaoNgay.value.giamSatDichBenhs =
      baoCao6Thang.value.giamSatDichBenhs = [
        {tenCuaKhau: "Sân Bay quốc tế Đà Nẵng", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}},
        {tenCuaKhau: "Cảng Đà Nẵng", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}},
      ];
      baoCaoNam.value.xetNghiems =
      baoCaoNgay.value.xetNghiems =
      baoCao6Thang.value.xetNghiems = [
        {loaiXetNghiem: "Xét nghiệm nước trên tàu"},
      ];
      /// bao cao tuan

      baoCaoTuan.value.cuaKhauDoiVoiNguois = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6},
        {viTri: "Cảng Đà Nẵng ->> Nhập cảnh ->> Tổng số", id: 7},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18},
      ];
      baoCaoTuan.value.cuaKhauPhuongTiens = [
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Tổng số", id: 1, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 2, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Tổng số", id: 3, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 4, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Tổng số", id: 5, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Sân bay quốc tế  Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 6, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Tổng số", id: 7, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Nhập cảnh -> Cộng dồn", id: 8, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Tổng số", id: 9, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Xuất cảnh -> Cộng dồn", id: 10, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Tổng số", id: 11, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Cảng Đà Nẵng -> Quá cảnh -> Cộng dồn", id: 12, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Tổng số", id: 13, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Nhập cảnh -> Cộng dồn", id: 14, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Tổng số", id: 15, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Xuất cảnh -> Cộng dồn", id: 16, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Tổng số", id: 17, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
        {viTri: "Tổng số -> Quá cảnh -> Cộng dồn", id: 18, phuongTienHangKhong: {}, phuongTienDuongBo: {}, phuongTienDuongSat: {}, phuongTienDuongThuy: {}},
      ];
    }
    initDb();
    const updateReportDay = () => {
      if(baoCaoNgay.value.thoiGianBaoCao == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.updateBaoCaoHDYTKDNgay(baoCaoNgay.value)
            .then((response) => {
              selectCalendarDay();
              toast.add({
                severity: 'warn',
                summary: 'Cập nhật báo cáo',
                detail: 'Cập nhật báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }
    const updateReport = () => {
      if(baoCao.value.tuNgay == null || baoCao.value.denNgay == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.updateBaoCaoHDYTKDThang(baoCao.value)
            .then((response) => {
              selectCalendar();
              toast.add({
                severity: 'warn',
                summary: 'Cập nhật báo cáo',
                detail: 'Cập nhật báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const loadDBMonth = (id) => {
      loadingData.value = true;
        CDCRepository.getBaoCaoHDYTKDThangById(id)
            .then((response) => {
              baoCaoThangShow.value = true;
              baoCao.value = response.data;
              loadingData.value = false;
            })
            .catch(err => {
              loadingData.value = false;
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
    }

    const loadDBWeek = (id) => {
      loadingData.value = true;
      CDCRepository.getBaoCaoHDYTKDTuanById(id)
          .then((response) => {
            baoCaoTuanShow.value = true;
            baoCaoTuan.value = response.data;
            loadingData.value = false;
          })
          .catch(err => {
            loadingData.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    const loadDB6Month = (id) => {
      loadingData.value = true;
      CDCRepository.getBaoCaoHDYTKD6ThangById(id)
          .then((response) => {
            baoCao6ThangShow.value = true;
            baoCao6Thang.value = response.data;
            loadingData.value = false;
          })
          .catch(err => {
            loadingData.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }
    const loadDBYear = (id) => {
      loadingData.value = true;
      CDCRepository.getBaoCaoHDYTKDNamById(id)
          .then((response) => {
            baoCaoNamShow.value = true;
            baoCaoNam.value = response.data;
            loadingData.value = false;
          })
          .catch(err => {
            loadingData.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }
    const loadDBDay = (id) => {
      loadingData.value = true;
      CDCRepository.getBaoCaoHDYTKNgayById(id)
          .then((response) => {
            baoCaoNgayShow.value = true;
            baoCaoNgay.value = response.data;
            selectDay();
            loadingData.value = false;
          })
          .catch(err => {
            loadingData.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

 const updateReport6Month = () => {
   if(baoCao6Thang.value.tuNgay == null || baoCao6Thang.value.denNgay == null)
   {
     toast.add({
       severity: 'error',
       summary: 'Lỗi',
       detail:'Vui lòng chọn thời gian báo cáo',
       life: 2000
     });
   }
   else {
     CDCRepository.updateBaoCaoHDYTKD6Thang(baoCao6Thang.value)
         .then((response) => {
           selectCalendar6Month();
           toast.add({
             severity: 'warn',
             summary: 'Cập nhật báo cáo',
             detail: 'Cập nhật báo cáo thành công vào hệ thống',
             life: 2000
           });
         })
         .catch(err => {
           toast.add({
             severity: 'error',
             summary: 'Lỗi',
             detail: err.response.data,
             life: 2000
           });
         });
   }
    }
 const updateReportYear = () => {
   if(baoCaoNam.value.tuNgay == null || baoCaoNam.value.denNgay == null)
   {
     toast.add({
       severity: 'error',
       summary: 'Lỗi',
       detail:'Vui lòng chọn thời gian báo cáo',
       life: 2000
     });
   }
   else {
     CDCRepository.updateBaoCaoHDYTKDNam(baoCaoNam.value)
         .then((response) => {
           selectCalendarYear();
           toast.add({
             severity: 'warn',
             summary: 'Cập nhật báo cáo',
             detail: 'Cập nhật báo cáo thành công vào hệ thống',
             life: 2000
           });
         })
         .catch(err => {
           toast.add({
             severity: 'error',
             summary: 'Lỗi',
             detail: err.response.data,
             life: 2000
           });
         });
   }
    }

    const updateReportWeek = () => {
      if(baoCao6Thang.value.tuNgay == null || baoCao6Thang.value.denNgay == null)
      {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Vui lòng chọn thời gian báo cáo',
          life: 2000
        });
      }
      else {
        CDCRepository.updateBaoCaoHDYTKDTuan(baoCaoTuan.value)
            .then((response) => {
              selectCalendarWeek();
              toast.add({
                severity: 'warn',
                summary: 'Cập nhật báo cáo',
                detail: 'Cập nhật báo cáo thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail: err.response.data,
                life: 2000
              });
            });
      }
    }

    const addTiemChung = () => {
      baoCao6Thang.value.tiemChungs.push({tenBenh:""});
    };

    const addGiamSat = () => {
      baoCao6Thang.value.giamSatDichBenhs.push({tenCuaKhau:"", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}});
    };
    const addXetNghiem = () => {
      // baoCao6Thang.value.xetNghiems = [
      //   {loaiXetNghiem: "Xét nghiệm nước trên tàu"},
      // ];
      baoCao6Thang.value.xetNghiems.push({loaiXetNghiem:""});
    }

    const addTiemChungNam = () => {
      baoCaoNam.value.tiemChungs.push({tenBenh:""});
    };

    const addGiamSatNam = () => {
      baoCaoNam.value.giamSatDichBenhs.push({tenCuaKhau:"", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}});
    };
    const addXetNghiemNam = () => {
      baoCaoNam.value.xetNghiems.push({loaiXetNghiem:""});
    }

    const addTiemChungNgay = () => {
      baoCaoNgay.value.tiemChungs.push({tenBenh:""});
    };

    const addGiamSatNgay = () => {
      baoCaoNgay.value.giamSatDichBenhs.push({tenCuaKhau:"", matDoChuot: {}, chiSoBoChet: {}, matDoMuoi: {}, soLuongDVDaDuocGiamSat: {}, soLuongCoSoSanXuat: {}});
    };
    const addXetNghiemNgay = () => {
      baoCaoNgay.value.xetNghiems.push({loaiXetNghiem:""});
    }

    const formatDateTime = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' DD/MM/YYYY');
    };

    const formatDateTimeHours = (date) => {
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format(' HH:mm DD/MM/YYYY');
    };

    const downloadFile = ref(false);
    const loadingBar = ref(false);
    const fileName6Month = ref("");
    const loadingExport = ref(false);
    const downLoadFileExport = (file, i) => {
      axios({
        url: '../api/cdc/downloadLoadFileReport/' + file,
        method: 'GET',
        responseType: 'blob',
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
            const link = document.createElement('a');
            link.href = url;
            if(i == 1) {
              link.setAttribute('download', "BaoCao6Thang.xlsx");
            }
            else  if(i == 2) {
              link.setAttribute('download', "BaoCaoThang.xlsx");
            }
            else if(i == 3){
              link.setAttribute('download', "BaoCaoTuan.xlsx");
            }
            else if(i == 4) {
              link.setAttribute('download', "BaoCaoNam.xlsx");
            }
            else if(i == 5) {
              link.setAttribute('download', "BaoCaoNgay.xlsx");
            }

            toast.add({
              severity: 'success',
              summary: 'Xuất dữ liệu',
              detail: 'Xuất dữ liệu thành công',
              life: 2000
            });
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2500
            })});
    };
    const exportFileDay = () => {
      loadingExport.value = true;
      downloadFile.value = false;
      CDCRepository.exportFileDay(baoCaoNgay.value)
          .then((response) => {
            fileName6Month.value = response.data;
            loadingExport.value = false;
            downloadFile.value = true
            downLoadFileExport(response.data, 5);
            // router.push({
            //   name: 'home'
            // });
          })
          .catch(err => {
            loadingExport.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    const exportFileYear = () => {
      loadingExport.value = true;
      downloadFile.value = false;
      CDCRepository.exportFileYear(baoCaoNam.value)
          .then((response) => {
            fileName6Month.value = response.data;
            loadingExport.value = false;
            downloadFile.value = true
            downLoadFileExport(response.data, 4);
            // router.push({
            //   name: 'home'
            // });
          })
          .catch(err => {
            loadingExport.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    const exportFile6Month = () => {
      loadingExport.value = true;
      downloadFile.value = false;
      CDCRepository.exportFile6Month(baoCao6Thang.value)
          .then((response) => {
            fileName6Month.value = response.data;
            loadingExport.value = false;
            downloadFile.value = true
            downLoadFileExport(response.data, 1);
            // router.push({
            //   name: 'home'
            // });
          })
          .catch(err => {
            loadingExport.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const exportFileMonth = () => {
      loadingExport.value = true;
      downloadFile.value = false;
      CDCRepository.exportFileMonth(baoCao.value)
          .then((response) => {
            fileName6Month.value = response.data;
            loadingExport.value = false;
            downloadFile.value = true
            downLoadFileExport(response.data, 2);
            // router.push({
            //   name: 'home'
            // });
          })
          .catch(err => {
            loadingExport.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const exportFileWeek = () => {
      loadingExport.value = true;
      downloadFile.value = false;
      CDCRepository.exportFileWeek(baoCaoTuan.value)
          .then((response) => {
            fileName6Month.value = response.data;
            loadingExport.value = false;
            downloadFile.value = true
            downLoadFileExport(response.data, 3);
            // router.push({
            //   name: 'home'
            // });
          })
          .catch(err => {
            loadingExport.value = false;
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }


    const fileNameMonth = ref("");
    const tuan = ref({} as DanhSachTuan)
    const selectDay = () => {
      const t = ref({} as ThoiGian);
      t.value.time = baoCaoNgay.value.thoiGianBaoCao;
      CDCRepository.getWeek(t.value)
          .then((response) => {
            tuan.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    return {
      date,
      service,
      baoCao,
      updateReport,
      baoCao6Thang,
      addTiemChung,
      addGiamSat,
      addXetNghiem,
      baoCaoTuan,
      updateReportWeek,
      updateReport6Month,
      listBaoCaoThang,
      listBaoCaoNgay,
      selectCalendar,
      clearCalendar,
      formatDateTime,
      loadDBMonth,
      baoCaoThangShow,
      baoCaoTuanShow,
      baoCaoNgayShow,
      baoCaoNgay,
      formatDateTimeHours,
      selectCalendarWeek,
      dateWeek,
      listBaoCaoTuan,
      loadDBWeek,
      selectCalendar6Month,
      selectCalendarYear,
      selectCalendarDay,
      date6Month,
      dateYear,
      dateDay,
      baoCao6ThangShow,
      baoCaoNamShow,
      loadDB6Month,
      listBaoCao6Thang,
      exportFile6Month,
      exportFileMonth,
      exportFileWeek,
      exportFileYear,
      exportFileDay,
      addTiemChungNam,
      addGiamSatNam,
      addXetNghiemNam,
      addTiemChungNgay,
      addGiamSatNgay,
      addXetNghiemNgay,
      baoCaoNam,
      listBaoCaoNam,
      updateReportYear,
      loadDBYear,
      loadDBDay,
      updateReportDay,
      tuan,
      selectDay,
      loadingExport
    }
  }

}
